export default __webpack_public_path__ + "media/images/iui/toggleOn-bdc4bbfb22b1547be2c7a2745d2d3a05.png";